<template>
  <div id="presenter" class="screen">
    <div class="section" style="text-align: center;">
      <div>
        <h5 class="title is-5">GDPR</h5>
        <v-btn v-on:click="prevSlide('GoLKEcn4leZqFyMiDqwZ')" class="button">
          <<<
        </v-btn>
        <v-btn v-on:click="reset('GoLKEcn4leZqFyMiDqwZ')" class="button">
          Reset
        </v-btn>
        <v-btn v-on:click="nextSlide('GoLKEcn4leZqFyMiDqwZ')" class="button">
          >>>
        </v-btn>
      </div>
      <img class="slide" style="height: 600px;" v-bind:src="currentSlideImage"/>
      <div>
        <h5 class="title is-5">Privacy in marketing</h5>
        <v-btn v-on:click="prevSlide('2xwuveOAccPvhXVnlzLB')" class="button">
          &lt;&lt;&lt;
        </v-btn>
        <v-btn v-on:click="reset('2xwuveOAccPvhXVnlzLB')" class="button">
          Reset
        </v-btn>
        <v-btn v-on:click="nextSlide('2xwuveOAccPvhXVnlzLB')" class="button">
          &gt;&gt;&gt;
        </v-btn>
      </div>
      <div>
        <h5 class="title is-5">Candy</h5>
        <v-btn v-on:click="prevSlide('yLenfiqf0uDEVCCGsCcO')" class="button">
          &lt;&lt;&lt;
        </v-btn>
        <v-btn v-on:click="reset('yLenfiqf0uDEVCCGsCcO')" class="button">
          Reset
        </v-btn>
        <v-btn v-on:click="nextSlide('yLenfiqf0uDEVCCGsCcO')" class="button">
          >>>
        </v-btn>
      </div>
      <div>
        <h5 class="title is-5">Surfing</h5>
        <v-btn v-on:click="prevSlide('KPDirw3Un94NkATTDU2P')" class="button">
          &lt;&lt;&lt;
        </v-btn>
        <v-btn v-on:click="nextSlide('KPDirw3Un94NkATTDU2P')" class="button">
          &gt;&gt;&gt;
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import presentationApi from '../api/presentationApi';

export default {
  name: 'PresenterTemp',
  created() {
    this.$store.dispatch('getCheckedInPresentation', 'GoLKEcn4leZqFyMiDqwZ');
  },
  computed: mapGetters([
    'currentSlideImage'
  ]),
  methods: {
    prevSlide(presentationId) {
      presentationApi.changeCurrentSlide(presentationId, false);
    },
    nextSlide(presentationId) {
      presentationApi.changeCurrentSlide(presentationId, true);
    },
    reset(presentationId) {
      presentationApi.resetPresentation(presentationId);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/PresenterDemo.vue